import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CervelloEduverseLanding from '../cervelloeduverse';
import JuniorAcademy from './components/JuniorAcademy.jsx';
import Elevare from './components/Elevare.jsx';
import BusinessLab from './components/BusinessLab.jsx';
import StudentLMS from './components/StudentLMS.jsx';
import BookDemo from './components/BookDemo.jsx';
import Testimonials from './components/Testimonials.jsx';
import CoursePage from './components/CoursePage.jsx';
import NotFound from './components/NotFound.jsx';
import ScrollToTop from './components/layout/ScrollToTop.jsx';
import CoursesPage from './components/CoursesPage.jsx';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<CervelloEduverseLanding />} />
        <Route path="/about" element={<CervelloEduverseLanding />} />
        <Route path="/programs" element={<CervelloEduverseLanding />} />
        <Route path="/contact" element={<CervelloEduverseLanding />} />
        <Route path="/junior-academy" element={<JuniorAcademy />} />
        <Route path="/elevare" element={<Elevare />} />
        <Route path="/business-lab" element={<BusinessLab />} />
        <Route path="/student-lms" element={<StudentLMS />} />
        <Route path="/book-demo" element={<BookDemo />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/courses" element={<CoursesPage />} />
        <Route path="/course/:courseSlug" element={<CoursePage />} />
        <Route path="/*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;